import { d as e, a as i } from "../../index-34b1f277.js";
const t = e({
  fontWeight: "medium",
  color: "primary.700",
  _dark: {
    color: "white"
  }
}), n = e({
  xl: {
    fontSize: "48px",
    lineHeight: "60px",
    letterSpacing: "0",
    a: {
      fontSize: "48px",
      fontWeight: t.fontWeight
    },
    strong: {
      fontWeight: 700
    },
    "& + h1, & + h2, & + h3, & + h4": {
      marginTop: "56px"
    }
  },
  lg: {
    fontSize: "32px",
    lineHeight: "40px",
    letterSpacing: "0",
    a: {
      fontSize: "32px",
      fontWeight: t.fontWeight
    },
    strong: {
      fontWeight: 700
    },
    "& + h1, & + h2, & + h3, & + h4": {
      marginTop: "36px"
    }
  },
  md: {
    fontSize: "24px",
    lineHeight: "33px",
    letterSpacing: "0",
    a: {
      fontSize: "24px",
      fontWeight: t.fontWeight
    },
    strong: {
      fontWeight: 700
    },
    "& + h1, & + h2, & + h3, & + h4": {
      marginTop: "32px"
    }
  },
  sm: {
    fontSize: "20px",
    lineHeight: "25px",
    letterSpacing: "0",
    a: {
      fontSize: "20px",
      fontWeight: t.fontWeight
    },
    strong: {
      fontWeight: 700
    },
    "& + h1, & + h2, & + h3, & + h4": {
      marginTop: "28px"
    }
  }
}), h = i({
  baseStyle: t,
  sizes: n,
  variants: {},
  defaultProps: {
    size: "lg"
  }
});
export {
  h as HeadingStyles
};
//# sourceMappingURL=Heading.styles.es.js.map
